import React from 'react';
import useSurfaceRealTimeUpdates from 'routes/surface/hooks/use-surface-real-time-updates';
import { useOnSurfaceChangeOperations } from 'routes/surface/hooks/use-on-surface-change';

export interface SurfaceSubscriptionListenersProps {
  surface: string;
}

function SurfaceSubscriptionListeners({
  surface,
}: SurfaceSubscriptionListenersProps) {
  const { setSurfaceId } = useOnSurfaceChangeOperations();

  React.useEffect(() => {
    setSurfaceId(surface);
  }, [surface]);

  useSurfaceRealTimeUpdates(surface);

  return null;
}

export default SurfaceSubscriptionListeners;
